"use client"

import { motion } from "framer-motion"
import { FaTrophy, FaCheck, FaCalendarAlt } from "react-icons/fa"

const CasosDestacados = ({ casos = [] }) => { // Establecemos un valor por defecto (empty array)
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-8"
    >
      <h2 className="text-2xl font-bold">Casos Destacados</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {casos.length > 0 ? (
          casos.map((caso, index) => (
            <motion.div
              key={caso.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.02 }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="flex items-start space-x-4">
                <div className="bg-[var(--navy-blue)] rounded-lg p-3">
                  <FaTrophy className="text-2xl text-[var(--gold)] " />
                </div>

                <div className="flex-1">
                  <h3 className="text-lg font-semibold mb-2">{caso.title}</h3>
                  <p className="text-gray-600 mb-4">{caso.description}</p>

                  <div className="flex items-center space-x-4 text-sm">
                    <div className="flex items-center text-green-600">
                      <FaCheck className="mr-1" />
                      <span>{caso.outcome}</span>
                    </div>

                    <div className="flex items-center text-gray-500">
                      <FaCalendarAlt className="mr-1" />
                      <span>{caso.year}</span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))
        ) : (
          <p>No hay casos destacados disponibles.</p> // Mensaje alternativo si no hay casos
        )}
      </div>
    </motion.div>
  )
}

export default CasosDestacados
